export const space = [0, 10, 20, 30, 40, 50, 60, 120, 240]
